import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ImagePreloaderService {
  preloadImages(images: string[]): Promise<void[]> {
    const promises = images.map((src) => this.preloadImage(src));
    return Promise.all(promises);
  }

  private preloadImage(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = src;

      image.onload = () => {
        // The image has been successfully preloaded.
        resolve();
      };

      image.onerror = () => {
        // There was an error preloading the image.
        reject(new Error(`Failed to preload image: ${src}`));
      };
    });
  }
}
